<script setup lang="ts">
import { computed } from 'vue';
import {
  useNotificationStore,
  type Notification,
  type NotificationType,
} from '@/stores/notifications';

const props = defineProps<Notification>();
const notifications = useNotificationStore();

function remove() {
  notifications.remove(props.id);
}

const [icon, color] = computed(() => {
  const map: Record<NotificationType, [string, string]> = {
    information: ['fa-info-circle', '#278ef5'],
    error: ['fa-times-circle', '#f76060'],
    warning: ['fa-exclamation-circle', '#e8bc2a'],
    success: ['fa-check-circle', '#42c389'],
  };
  return map[props.type];
}).value;
</script>

<template>
  <div class="notification">
    <span style="grid-area: icon" :style="{ color }"><v-icon :name="icon" /></span>
    <span style="grid-area: title; font-weight: 700" :style="{ color }">{{ props.title }}</span>
    <span style="grid-area: body">{{ props.message }}</span>
    <span style="grid-area: close; justify-self: end; cursor: pointer" @click="remove">
      <v-icon name="fa-times" />
    </span>
  </div>
</template>

<style scoped>
.notification {
  background-color: #262831;
  /* background-color: #eceef8; */
  box-shadow: #1e1f24 2px 2px 6px;
  border-radius: 0.25rem;
  padding: 0.75rem;
  color: #bbc1c7;
  width: 20rem;
  display: grid;
  row-gap: 0.5rem;
  grid-template-areas:
    'icon title close'
    '. body .';
  grid-template-columns: 2rem 1fr 2rem;
  z-index: 100;
  position: relative;
}
</style>
